import { NgModule } from '@angular/core';
import { WpsNgComponent } from './wps-ng.component';



@NgModule({
  declarations: [WpsNgComponent],
  imports: [
  ],
  exports: [WpsNgComponent]
})
export class WpsNgModule { }
